import * as yup from "yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { INVALID_CREDENTIALS } from "./../../../utils/constants";
import Textbox from "../../../components/common/Textbox";
import TextboxPassword from "../../../components/common/TextboxPassword";
import Loader from "../../../components/common/Loader";
import authService from "./../../../services/authService";

const schema = yup.object({
  email: yup
    .string()
    .required("Please enter your email address.")
    .email("Please enter a valid email address."),
  password: yup.string().required("Please enter your password."),
});

const LoginForm = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isInvalid, setInvalid] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      await authService.loginAsync(data.email, data.password);
      window.location = "/";
    } catch (ex) {
      if (ex.response && ex.response.data.message === INVALID_CREDENTIALS)
        setInvalid(true);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 2500);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="py-2 px-14 space-y-6">
      {isLoading && <Loader />}
      {isInvalid && (
        <div className="border-l-4 p-4 border-red-400 bg-red-100">
          <p className="text-red-400 mb-3">Invalid Credentials</p>
          <span className="text-sm text-gray-500">
            The email and password you entered did not match our records. Please
            double-check and try again.
          </span>
        </div>
      )}
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <Textbox
            id="email-textbox"
            name="email"
            type="Email"
            placeholder="Email Address"
            register={register("email")}
            errors={errors}
            autoFocus
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <TextboxPassword
            id="password-textbox"
            name="password"
            placeholder="Password"
            register={register("password")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2 mt-4">
          <button type="submit" className="button button-primary">
            Sign In
          </button>
        </div>
      </div>
    </form>
  );
};

export default LoginForm;
